import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'edit-tab-title-modal',
  templateUrl: './edit-tab-title-modal.component.html',
  styleUrls: ['./edit-tab-title-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditTabTitleModalComponent implements OnInit {
  public tabTitleForm: UntypedFormGroup;
  public previousTabTitle: string;

  // Form Controls acessor.
  public get formControls(): {
    [key: string]: AbstractControl;
  } {
    return this.tabTitleForm.controls;
  }

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public dialogData: { previousTabTitle: string },
    private readonly matDialogRef: MatDialogRef<EditTabTitleModalComponent>,
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.tabTitleForm = this.formBuilder.group({
      tabTitleControl: ['', [Validators.maxLength(30)]],
    });
    this.previousTabTitle = this.dialogData.previousTabTitle;
  }

  public discard(): void {
    this.matDialogRef.close();
  }

  public save(): void {
    this.matDialogRef.close(this.tabTitleForm.get('tabTitleControl').value);
  }
}
